import { Button } from '@1trading/react';
import { LogOut } from 'lucide-react';
import { useAuthStore } from '@/lib/auth/store';

export const AuthUser = () => {
  const user = useAuthStore((state) => state.user);

  if (!user) return null;

  // Form POST: a top-level navigation (only that clears the HttpOnly cookie and can follow
  // the Keycloak logout redirect), but never a GET — browsers speculatively load GET URLs
  // from history with cookies, which was silently signing users out.
  return (
    <div className="flex min-w-0 flex-1 items-center gap-2">
      <div className="min-w-0 flex-1 group-data-[collapsible=icon]:hidden">
        <p className="truncate text-sm font-medium">{user.name}</p>
        <p className="truncate text-xs text-muted-foreground">{user.email}</p>
      </div>
      <form action="/api/auth/logout" method="post">
        <Button aria-label="Sign out" size="icon" type="submit" variant="ghost">
          <LogOut className="size-4" />
        </Button>
      </form>
    </div>
  );
};
AuthUser.displayName = 'AuthUser';
